import React from 'react';
import { useTranslation } from 'react-i18next';
import { managerContent_exploreCategory_subCategories } from 'Managers/graphql/__generated__/managerContent';
import { SectionHeadingTitle } from 'Managers/styles';
import useViewportWidth from 'utils/useViewportWidth';
import { Breakpoints } from '@unmind/design-system-theme';
import RoutePath from '../../../App/RoutePath';
import GenericExploreContent from '../../../Explore/GenericExploreContent/GenericExploreContent';
import * as S from './styles';

export interface CategorySectionProps {
  category: managerContent_exploreCategory_subCategories;
  assetToken?: string | null;
}

export const ManagersCategorySection = ({
  category,
  assetToken,
}: CategorySectionProps) => {
  const { t: translate } = useTranslation('homepage');
  const width = useViewportWidth();

  // On mobile screens we show 2 items, on desktop 3
  const viewAllLimit = width <= Breakpoints.XS ? 2 : 3;
  const viewAll = (category.content?.length ?? 0) > viewAllLimit;

  return category.content?.length ? (
    <S.ManagersCategorySectionContainer>
      <S.HeadingWrapper>
        <SectionHeadingTitle>{category.title}</SectionHeadingTitle>
        <S.ArrowWrapper>
          {viewAll ? (
            <S.StyledLink
              to={{
                pathname: `${RoutePath.Explore}/${category.slug}`,
                state: { from: location.pathname },
              }}
              aria-label={translate(
                'your_courses_section.arrow_link_button.text',
              )}
            >
              <S.StyledText>
                {translate('your_courses_section.arrow_link_button.text')}
              </S.StyledText>
            </S.StyledLink>
          ) : null}
        </S.ArrowWrapper>
      </S.HeadingWrapper>
      <GenericExploreContent
        content={category.content.filter(
          (item): item is NonNullable<typeof item> => item !== null,
        )}
        assetToken={assetToken}
        source="managers-category"
        showDescription={true}
      />
    </S.ManagersCategorySectionContainer>
  ) : null;
};
